import React, { useCallback, useEffect, useMemo } from 'react'
import { useInstData } from 'tyan/public/hooks'
import { ContainerField, Container } from '@sencha/ext-modern'
import { getMixedProps } from './blockPublic'

const IFrame = ({ field, /* onChange, initValues, changedValues,  */defaultStyle }) => {
	const { src, onRegisterFrame, onUnRegisterFrame, onRegisterDoEvent, onUnRegisterDoEvent, onMessage, loadMessage, onLoad, scrolling } = field
	const { props: { label, ...props } } = getMixedProps('_iframe', [defaultStyle, field])
	const { me, me: { iframeID } } = useInstData(props, useMemo(() => ({ iframeID: `_iframe-${Tyan.getUuid()}` })))
	// return <FieldSet title={label} {...props}  >
	// 	<div dangerouslySetInnerHTML={{ __html: value }} />
	// </FieldSet>

	useEffect(() => {
		//注册事件
		onRegisterFrame && onRegisterFrame(me.iframe)
		onRegisterDoEvent && onRegisterDoEvent((args) => me.iframe && me.iframe.contentWindow.postMessage(args, "*"))

		//卸载事件
		return () => {
			onUnRegisterFrame && onUnRegisterFrame()
			onUnRegisterDoEvent && onUnRegisterDoEvent()
		}
	}, [])

	useEffect(() => {
		var doc = me.iframe.contentDocument || me.iframe.document
		doc && doc.body && (doc.body.innerHTML = '数据加载中...')
		src && (me.iframe.src = src)
	}, [src])

	useEffect(() => {
		if (onMessage) {
			const handleMessage = event => {
				if (me.iframe && (me.iframe.contentWindow === event.source)) {
					event.preventDefault()
					event.cancelBubble = true
					event.stopPropagation()
					event.stopImmediatePropagation()
					onMessage(event.data)
					return
				}
			}

			window.addEventListener('message', handleMessage)
			return () => {
				window.removeEventListener('message', handleMessage)
			}
		}
	}, [onMessage])

	const handleOnLoad = useCallback(() => {
		if (!me.iframe) {
			setTimeout(handleOnLoad)
			return
		}
		loadMessage && me.iframe.contentWindow.postMessage(loadMessage, "*")
		onLoad && onLoad()
	}, [])

	return <ContainerField id={iframeID} label={label} layout='fit'/* layout={{ type: 'vbox', pack: 'center', align: 'stretch' }} */ {...props}>
		<Container layout='fit' errorTarget={undefined}>
			<div style={{ flex: 1 }}>
				<iframe
					ref={ref => ref && (/* window.iframe =  */me.iframe = ref)}
					//style={{ width: '100%', height: '1500', overflow: 'visible' }}
					width="100%"
					height="100%"
					scrolling={scrolling ? scrolling : 'yes'}
					frameBorder="0"
					onLoad={handleOnLoad}
					allow='microphone;camera;'
				/>
			</div>
		</Container>
	</ContainerField>
}

const renderIFrame = config => {
	const { key } = config.field || {}
	return <IFrame key={key} {...config} />
}

export default renderIFrame